/** Validate a website address without rewriting the saved answer. */
export function isWebsiteAnswer(value: string): boolean {
  return /^(?:https?:\/\/)?(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/\S*|\?[a-zA-Z0-9=&%]*(?:#[a-zA-Z0-9-]*)?|#[a-zA-Z0-9-]*)?$/.test(value.trim());
}

/** Shared email syntax for authored and imported email questions. */
export function isEmailAnswer(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

/** Discard obsolete source validation settings while preserving the saved field. */
export function stripLegacyValidationProfiles<T>(value: T): T {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  const field = { ...value } as Record<string, unknown>;
  delete field.urlValidationProfile;
  delete field.emailValidationProfile;
  return field as T;
}
